import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getVisscostandsecdeposite } from "../../../../store/Api";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import Highlighter from "react-highlight-words";
import { CgSpinner } from "react-icons/cg";
import { GrFormView } from "react-icons/gr";
import { useLocation, useNavigate } from "react-router-dom";
import VisaCostedit from "./visacostedit";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import VisacostOnarrivalMain from "../visacost&secDeposite-OnArrival/visaIndex";
import Employeeseclist from "../visacost&secDeposite-OnArrival/Editemployeelist";
import nodeinstance from "../../../../nodeInstance";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SecDeposite from "../../DummyPdfs/visacostSecdepositePDF/SecdepositePDF";
import { pdf } from "@react-pdf/renderer";
import SecDepositImmediate from "./SecDeposit_Immediate";
import Trigger from "./trigger";

export default function Visacostandsecdeposite() {
  const dispatch = useDispatch();
  const visaCostandsecdeposite = useSelector(
    (state) => state.visacostsecDeposite
  );
  const token = localStorage.getItem("nodeToken");
  useEffect(() => {
    dispatch(getVisscostandsecdeposite(token));
  }, []);
  const [route, setRoute] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  const location = useLocation();

  useEffect(() => {
    if (location.pathname.split("/")[3] === "summary") {
      console.log("hjgjydgygyuguguy", location.pathname.split("/")[3]);
      // setRoute(true);
      setAddOrEdit((p) => ({ ...p, open: true, method: "Immediate" }));
    } else if (location.pathname.split("/")[3] === "summary-OnArrival") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "OnArrival" }));
    } else if (
      location.pathname.split("/")[3] === "summary-OnArrival-editEmployee"
    ) {
      setAddOrEdit((p) => ({ ...p, open: true, method: "Editbatch" }));
    } else {
      setRoute(false);
      setAddOrEdit((p) => ({ ...p, open: true, method: "" }));
      // window.location.reload()
    }
  }, [location]);
  const navigate = useNavigate();

  const [searchWords, setSearchWords] = useState([]);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList: originalCurrentList,
  } = useSearchPagination(visaCostandsecdeposite?.data);
  const currentList = [...originalCurrentList].sort((a, b) => {
    const dateA = new Date(a.created_at || a.updated_at);
    const dateB = new Date(b.created_at || b.updated_at);
    return dateB - dateA;
  });

  const titles = [
    "S.NO",
    "CONTRACT NO",
    "QUOTATION NO",
    "CLIENT",
    "VISA PROVIDER",
    "CONTRACT STATUS",
    "ANNEXURE STATUS",
    "COC ATTESTATION",
    "START DATE",
    "END DATE",
    "INVOICE FOR VISA COST",
    "INVOICE FOR SECURITY DEPOSIT",
    "Contract_type",
    "ACTION",
  ];
  console.log("visaCostandsecdeposite", currentList);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [propData, setPropData] = useState();
  const [quotationType, setQuotationType] = useState();
  const handleIconClick = (id, name, Contract_type) => {
    setPropData(id);
    setQuotationType(name);
    if (Contract_type === "ON-ARRIVAL") {
      // alert("route to On Arrival page from here.....")
      navigate("/dashboard/visa-cost-&-sec-deposit/summary-OnArrival");
      return;
    }
    navigate("/dashboard/visa-cost-&-sec-deposit/summary");
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "------";
    }
    const date = new Date(dateString);
    const monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDate = `${day}-${monthNames[monthIndex]}-${year}`;
    return formattedDate;
  }
  function calculateEndDate(startDate, tenure) {
    if (!startDate) {
      return "------";
    }
    const start = new Date(startDate);
    const end = new Date(start);

    end.setMonth(end.getMonth() + tenure);

    if (end.getDate() < start.getDate()) {
      end.getDate(0);
    }
    return formatDate(end);
  }

  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "VISA COST AND SECURITY DEPOSIT",
          link: "",
        },
      ])
    );
  }, [location]);

  const [onArivalInvoice, setOnArrivalInvoice] = useState();

  const downloadReport = async () => {
    try {
      console.log("..........propData......", propData);
      const response = await nodeinstance.get(
        `/dashboard/visaSecurity/excelDownload`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Visa-cost-security-deposite--OnArrival-report`
        );
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        // setExcelDownload(false);
      }
    } catch (error) {
      console.log("error to be displayed here....", error);
      dispatch(
        setAppError({
          msg: "Error while generating report",
        })
      );
    }
  };

  const [downloadPDF, SetDownloadPDF] = useState(false);

  const [data1, setData1] = useState();
  const [data2, setData2] = useState();

  return (
    <>
      {addOrEdit.method === "Immediate" ? (
        <VisaCostedit
          propData={propData}
          quotationType={quotationType}
          SetDownloadPDF={SetDownloadPDF}
          setData1={setData1}
          setData2={setData2}
        />
      ) : addOrEdit.method === "OnArrival" ? (
        <VisacostOnarrivalMain
          quotationType={quotationType}
          propData={propData}
          setOnArrivalInvoice={setOnArrivalInvoice}
        />
      ) : addOrEdit.method === "Editbatch" ? (
        <Employeeseclist
          invoiceNumber={onArivalInvoice}
          quotationType={quotationType}
        />
      ) : (
        <>
          <div className="pt-2 uppercase">
            <div className="flex flex-wrap gap-2 items-center">
              <Search
                keywords={[
                  "contract_number",
                  "quotation_number",
                  "client",
                  "visa_provider",
                  "contract_status",
                ]}
                setSearchWords={setSearchWords}
                className="ml-auto text-lg"
              />
              <button
                className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
                // onClick={() => downloadFile()}
                // disabled={downloadLoading || list?.isLoading}
                onClick={() => {
                  downloadReport();
                }}
              >
                <p>Download Visa Cost & Sec Deposit</p>
                {downloadLoading && <CgSpinner className="animate-spin" />}
              </button>
            </div>
            <div
              className="overflow-x-auto m-2"
              style={{ backgroundColor: "white" }}
            >
              <table className="min-w-full divide-gray-200">
                <thead className="bg-gray-100">
                  <tr>
                    {titles.map((columnName, index) => (
                      <th
                        key={index}
                        scope="col"
                        className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                      >
                        {columnName}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-gray-10">
                  {currentList?.map((listItem, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem?.contract_number === null
                            ? "-----"
                            : listItem?.contract_number}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.quotation_number}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.client}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.visa_provider === null
                            ? "----"
                            : listItem.visa_provider}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.contract_status}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.annexure_status}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.coc_attestation}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {formatDate(listItem.start_date)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {/* {new Date(listItem.start_date).setMonth(
                        new Date(listItem.start_date).getMonth() + parseInt(listItem.tenure)
                      )} */}
                          {/* { new Date(listItem.start_date.getFullYear(), listItem.start_date.getMonth() + parseInt(listItem.tenure), listItem.start_date.getDate())} */}
                          {calculateEndDate(
                            listItem.start_date,
                            parseInt(listItem.tenure)
                          )}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.invoice_for_visa_cost}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.invoice_for_security_deposit}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          {listItem.Contract_type
                            ? listItem.Contract_type
                            : "---------"}
                        </td>
                        <button
                          className="px-6 py-4 whitespace-nowrap"
                          style={{
                            cursor: "pointer",
                            border: "none",
                            background: "none",
                            display: "inline-block",
                          }}
                          disabled={
                            listItem.invoice_for_visa_cost === "NO" &&
                            listItem.invoice_for_security_deposit === "NO"
                          }
                          onClick={() => {
                            handleIconClick(
                              listItem,
                              listItem.quotation_type,
                              listItem.Contract_type
                            );
                          }}
                        >
                          <GrFormView size={"2rem"} />
                        </button>
                      </tr>
                      <tr>
                        <td
                          className="border-t"
                          style={{ borderTop: "1px solid rgba(0, 0, 0, 0.1)" }}
                          colSpan={titles.length}
                        ></td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination />
        </>
      )}
    </>
  );
}
